import * as React from 'react';
import { RouteProps } from 'react-router';

import { AddCampaignPage } from './AddCampaignPage';
import { CampaignsPage } from './CampaignsPage';
import { ConfirmRegistration } from './ConfirmRegistration';
import { ForgotPassword } from './ForgotPassword';
import { Login } from './Login';
import { Register } from './Register';
import { ResetPassword } from './ResetPasswordPage';
import { TemplatesPage } from './TemplatesPage';
import { UpdateCampaignPage } from './UpdateCampaignPage';

export interface CustomRouteProps extends RouteProps {
  path: string;
  icon?: React.ReactElement;
  label?: string;
}

interface Routes {
  redirectTo: string;
  public: Array<CustomRouteProps>;
  private: Array<CustomRouteProps>;
}

export const LOGIN_ROUTE = '/login';
export const REGISTER_ROUTE = '/register';
export const CONFIRM_ROUTE = '/confirm';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const TEMPLATES_ROUTE = '/templates';
export const CAMPAIGNS_ROUTE = '/campaigns';
export const CREATE_CAMPAIGN_ROUTE = '/campaigns/create';
export const UPDATE_CAMPAIGN_ROUTE = '/campaigns/:campaignId';

const privateDefaultPath = TEMPLATES_ROUTE;

const routes: Routes = {
  redirectTo: LOGIN_ROUTE,
  public: [
    { path: LOGIN_ROUTE, render: () => <Login defaultPath={privateDefaultPath} /> },
    { path: REGISTER_ROUTE, render: () => <Register defaultPath={privateDefaultPath} /> },
    { path: CONFIRM_ROUTE, render: () => <ConfirmRegistration defaultPath={privateDefaultPath} /> },
    { path: FORGOT_PASSWORD_ROUTE, render: () => <ForgotPassword defaultPath={privateDefaultPath} /> },
    { path: RESET_PASSWORD_ROUTE, render: () => <ResetPassword defaultPath={privateDefaultPath} /> },
  ],
  private: [
    { label: 'TEMPLATES', path: TEMPLATES_ROUTE, component: TemplatesPage },
    { label: 'CAMPAIGNS', path: CAMPAIGNS_ROUTE, component: CampaignsPage },
    { path: CREATE_CAMPAIGN_ROUTE, component: AddCampaignPage },
    { path: UPDATE_CAMPAIGN_ROUTE, component: UpdateCampaignPage },
  ],
};

export function getMenuItems(routes: Array<CustomRouteProps>) {
  return routes.filter(({ icon, label }) => Boolean(icon || label));
}

export default routes;
